var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M31.087 22.614l-7-3c-0.173-0.075-0.375-0.119-0.587-0.119-0.468 0-0.886 0.213-1.162 0.547l-0.002 0.003-3.099 3.786c-4.885-2.34-8.734-6.189-11.014-10.935l-0.060-0.139 3.788-3.099c0.337-0.279 0.55-0.696 0.55-1.164 0-0.212-0.044-0.414-0.123-0.597l0.004 0.010-3-7c-0.239-0.535-0.767-0.901-1.38-0.901-0.122 0-0.24 0.014-0.353 0.042l0.010-0.002-6.496 1.493c-0.67 0.161-1.16 0.754-1.163 1.462v0c0 0.001 0 0.001 0 0.002 0 16.015 12.983 28.998 28.998 28.998 0.001 0 0.002 0 0.002 0h-0c0.708-0.003 1.301-0.493 1.46-1.153l0.002-0.010 1.508-6.5c0.024-0.101 0.038-0.217 0.038-0.337 0-0.618-0.372-1.15-0.905-1.382l-0.010-0.004z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.93ca01ee.svg";
export { ForwardRef as ReactComponent };